"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdornedInputMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Adornment = require("../../components/Adornment/Adornment.styles");
var _AdornmentLeft = require("../../components/AdornmentLeft/AdornmentLeft.styles");
var _AdornmentRight = require("../../components/AdornmentRight/AdornmentRight.styles");
var _Input = require("../../components/Input/Input.styles");
var _autofillBackgroundMixin = require("../autofillBackgroundMixin");
var _disabledMixin = require("../disabledMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var leftCSS = function leftCSS(props) {
  return props.leftAdornment ? (0, _styledToken.default)({
    paddingLeft: 'Adornment.Left.paddingLeft',
    borderLeft: 'Adornment.Left.borderLeft',
    borderTopLeftRadius: 'Adornment.Left.borderTopLeftRadius',
    borderBottomLeftRadius: 'Adornment.Left.borderBottomLeftRadius'
  }, function (_ref) {
    var _ref$paddingLeft = _ref.paddingLeft,
      paddingLeft = _ref$paddingLeft === void 0 ? 0 : _ref$paddingLeft,
      _ref$borderLeft = _ref.borderLeft,
      borderLeft = _ref$borderLeft === void 0 ? 0 : _ref$borderLeft,
      _ref$borderTopLeftRad = _ref.borderTopLeftRadius,
      borderTopLeftRadius = _ref$borderTopLeftRad === void 0 ? 0 : _ref$borderTopLeftRad,
      _ref$borderBottomLeft = _ref.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref$borderBottomLeft === void 0 ? 0 : _ref$borderBottomLeft;
    return (0, _styledComponents.css)(["> ", "{padding-left:", "px;border-left:", ";border-top-left-radius:", "px;border-bottom-left-radius:", "px;}"], _Input.StyledInput, paddingLeft, borderLeft, borderTopLeftRadius, borderBottomLeftRadius);
  })(props) : '';
};
var rightCSS = function rightCSS(props) {
  return props.rightAdornment ? (0, _styledToken.default)({
    paddingRight: 'Adornment.Right.paddingRight',
    borderRight: 'Adornment.Right.borderRight',
    borderTopRightRadius: 'Adornment.Right.borderTopRightRadius',
    borderBottomRightRadius: 'Adornment.Right.borderBottomRightRadius'
  }, function (_ref2) {
    var _ref2$paddingRight = _ref2.paddingRight,
      paddingRight = _ref2$paddingRight === void 0 ? 0 : _ref2$paddingRight,
      _ref2$borderRight = _ref2.borderRight,
      borderRight = _ref2$borderRight === void 0 ? 0 : _ref2$borderRight,
      _ref2$borderTopRightR = _ref2.borderTopRightRadius,
      borderTopRightRadius = _ref2$borderTopRightR === void 0 ? 0 : _ref2$borderTopRightR,
      _ref2$borderBottomRig = _ref2.borderBottomRightRadius,
      borderBottomRightRadius = _ref2$borderBottomRig === void 0 ? 0 : _ref2$borderBottomRig;
    return (0, _styledComponents.css)(["> ", "{padding-right:", "px;border-right:", ";border-top-right-radius:", "px;border-bottom-right-radius:", "px;}"], _Input.StyledInput, paddingRight, borderRight, borderTopRightRadius, borderBottomRightRadius);
  })(props) : '';
};
var errorCSS = function errorCSS(props) {
  var error = props.error;
  if (!error) {
    return '';
  }
  return (0, _styledToken.default)('Input.borderColorError', function (borderColor) {
    return (0, _styledComponents.css)(["> ", "{&,&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}}"], _Input.StyledInput, _Adornment.StyledAdornment, borderColor);
  })(props);
};
var readOnlyLeftCSS = function readOnlyLeftCSS(props) {
  var leftAdornment = props.leftAdornment,
    readOnly = props.readOnly;
  if (!readOnly || !leftAdornment) {
    return '';
  }
  return (0, _styledComponents.css)(["", "{padding-right:", ";}"], _AdornmentLeft.StyledAdornmentLeft, (0, _spaceMixin.spaceMixin)('sm')(props));
};
var readOnlyRightCSS = function readOnlyRightCSS(props) {
  var rightAdornment = props.rightAdornment,
    readOnly = props.readOnly;
  if (!readOnly || !rightAdornment) {
    return '';
  }
  return (0, _styledComponents.css)(["", "{padding-left:", ";}"], _AdornmentRight.StyledAdornmentRight, (0, _spaceMixin.spaceMixin)('sm')(props));
};

/** @class AdornedInputMixin */
/** @method */
var AdornedInputMixin = function AdornedInputMixin(props) {
  var fluid = props.fluid;
  return (0, _styledToken.default)({
    backgroundColor: 'Input.backgroundColor',
    backgroundColorAutofill: 'Input.backgroundColorAutofill',
    backgroundColorInteractive: 'Input.backgroundColorInteractive',
    borderColorInteractive: 'Input.borderColorInteractive',
    borderColor: 'Input.borderColor',
    borderRadius: 'Adornment.borderRadius',
    focusBoxShadow: 'Adornment.boxShadow.focus',
    readOnlyBackgroundColor: 'Adornment.ReadOnly.backgroundColor',
    readOnlyBorderColor: 'Adornment.ReadOnly.borderColor'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      backgroundColorAutofill = _ref3.backgroundColorAutofill,
      backgroundColorInteractive = _ref3.backgroundColorInteractive,
      borderColorInteractive = _ref3.borderColorInteractive,
      borderColor = _ref3.borderColor,
      borderRadius = _ref3.borderRadius,
      focusBoxShadow = _ref3.focusBoxShadow,
      readOnlyBackgroundColor = _ref3.readOnlyBackgroundColor,
      readOnlyBorderColor = _ref3.readOnlyBorderColor;
    return (0, _styledComponents.css)(["display:", ";> ", "{flex:0 0 auto;}> ", "{order:-1;}> ", "{min-width:0;&:-webkit-autofill ~ ", "{", "}&.edge-autofilled ~ ", "{background-color:", ";}&:active:not([disabled]),&:focus{& ~ ", "{background-color:", ";}}&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}&:focus{box-shadow:none;}&:focus:-webkit-autofill{", "}&[disabled] ~ ", "{", " &,&:hover,&:active,&:focus{background-color:", ";border-color:", ";}}&[readonly],&[readonly]:hover,&[readonly]:active,&[readonly]:focus{& ~ ", "{background-color:", ";border-color:", ";}}}&:focus-within{border-radius:", "px;box-shadow:", ";}", " ", " ", " ", " ", " ", ""], fluid ? 'flex' : 'inline-flex', _Adornment.StyledAdornment, _AdornmentLeft.StyledAdornmentLeft, _Input.StyledInput, _Adornment.StyledAdornment, (0, _autofillBackgroundMixin.autofillBackgroundMixin)(props), _Adornment.StyledAdornment, backgroundColorAutofill, _Adornment.StyledAdornment, backgroundColorInteractive, _Adornment.StyledAdornment, borderColorInteractive, (0, _autofillBackgroundMixin.autofillBackgroundMixin)(props), _Adornment.StyledAdornment, (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
      disabled: true
    })), backgroundColor, borderColor, _Adornment.StyledAdornment, readOnlyBackgroundColor || 'transparent', readOnlyBorderColor || 'transparent', borderRadius, focusBoxShadow, (0, _spacingMixin.spacingMixin)(props), leftCSS(props), rightCSS(props), errorCSS(props), readOnlyLeftCSS(props), readOnlyRightCSS(props));
  });
};
exports.AdornedInputMixin = AdornedInputMixin;